@if (!isLoading) {
  <div class="insight-container" [hidden]="showingShiftDetail">

    <div class="report-menu">
      <div class="report-title-with-actions">
        <div class="pt-15">
          <button mat-button
                  color="accent"
                  (click)="goBack()"
          >
            <mat-icon>arrow_back</mat-icon>
            <span class="text-primary">Back to Storm Report</span>
          </button>
        </div>

        <div class="report-menu__actions">
          <button
            mat-icon-button
            (click)="closeInsight()"
            [matTooltip]="'Close'"
            aria-label="close storm detail"
            class="report-button"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="shift-map-content">
      @if (storm && stormShifts && configuration) {
        <div class="shift-map-left-panel">
          <app-storm-panel
            [configuration]="configuration"
            [storm]="storm"
            [shifts]="stormShifts"
            [observations]="stormObservations"
          >
          </app-storm-panel>
        </div>
      }

      <div class="map-preview-container" #mapContainer>
        @if (!!mapContent) {
          <app-map-preview
            [nextContent]="mapContent"
            [mapTitle]="'Storm Map'"
          >
          </app-map-preview>

          @if (storm) {
            <div class="storm-control">
              <app-storm-control
                [stormMapContent]="mapContent"
                [storm]="storm"
                [time]="filterUnixTime"
                (timeChanged)="filter($event)"
                (speedChanged)="onSpeedUpdate($event)"
              ></app-storm-control>
            </div>
          }
        }
      </div>
    </div>
  </div>

  <router-outlet name="shift"></router-outlet>
}
